import {
  CentraCheckoutApiMappers,
  defaultCentraCheckoutApiMappers,
} from "@made-people/grease-centra";

export const mmOrderTotals: CentraCheckoutApiMappers["centraCheckoutApiOrderTotalsToGreaseOrderTotals"] =
  (totals, items, currencyFormat) => {
    const base =
      defaultCentraCheckoutApiMappers.centraCheckoutApiOrderTotalsToGreaseOrderTotals(
        totals,
        items,
        currencyFormat,
      );

    return {
      ...base,
      subtotal: {
        number: totals.itemsTotalPriceAsNumber,
        formatted: totals.itemsTotalPrice,
      },
    };
  };
